import { Table, TournamentStatus } from '@repo/database/src/types';

import { PlayerStats } from '../../event-types';

export interface TableWithPlayers {
  tableId: string;
  table?: Table;
  // Whether the table is marked active in the TournamentTableAssignment
  // Optional so other producers (e.g., tournament-server cache) don't need to set it
  active?: boolean;
  playerCount: number;
  players: {
    userId: string;
    alias: string;
    countryCode: string;
    seat: number;
    stack: number;
    playerIndex?: number | null;
  }[];
}

export interface TournamentTableState {
  tournamentId: string;
  tournamentName: string;

  breakDurationInMinutes: number;
  blindIntervalInMinutes: number;
  entries: number;

  cancelled: boolean;
  paused: boolean;
  resumingAt?: Date;

  isHandByHandEnabled: boolean;

  onBreak: boolean;
  waitingForBreak: boolean;
  breakEndAt?: Date | null;

  currentLevel: number;
  levelEndAt: Date | null;
  timeLeftInLevel: number | null;

  pendingLevelChange: boolean;

  pendingHandByHandChange: boolean;
  isEnteringHandByHand: boolean;
  isEnteringInTheMoney: boolean;

  // New state for when tournament goes from 1 to 2 players during late registration
  waitingForHandToStart: boolean;
  handStartsAt?: Date | null;

  averageStack?: number;
  playersStats?: Record<string, PlayerStats>;

  playersRemaining: number;

  lateRegistrationTime?: Date | null;
  // TODO: remove this once we have the startTime in the tournament state
  startTime: Date | null;

  levelsGoingUp: boolean;
  tournamentStatus: TournamentStatus;
  winner?: string | null;
  // Optional local UI flag used by the table when it becomes Final Table
  isFinalTable?: boolean;
  finalTableAwaitingPlayers?: boolean;
}

export enum TournamentCategory {
  ALL = 'All',
  SNG = 'SNG',
  PHENOM_SERIES = 'Phenom Series',
  SATELLITES = 'Satellites',
  PRIVATE = 'Private',
  TICKETS = 'Tickets',
  HISTORY = 'History',
}
